import React from 'react';
import Input from '../../../../common/input';
import CancelButtonLink from '../../../../common/buttons/cancelButtonLink';
import SimpleHeader from '../../../headers/simpleHeader';
import * as shapes from '../shapes';

const Form = ({ handleSubmit, pristine, submitting, valid, edit, onDelete, baseUrl, title }) => (
  <div className="c-wrapper">
    <SimpleHeader heading={title} />
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <h2 className="c-heading c-heading--lightgrey u-mb">Categories</h2>
        <form onSubmit={handleSubmit}>
          <fieldset disabled={submitting}>
            <div className="u-ph">
              <div className="layout">
                <div className="layout__item">
                  <span className="c-label-new">Name</span>
                  <Input className="c-input" name="name" type="text" placeholder="Category name" />
                </div>
              </div>
            </div>
            <div className="c-separator u-mv" />
            <div className="u-text-right">
              <button
                type="button"
                className="c-btn c-btn--red u-width-120 u-mr- u-float-left"
                onClick={onDelete}
                display-if={edit}
              >
                <span className="c-btn__text">Delete</span>
              </button>
              <CancelButtonLink link={baseUrl} content="Cancel" />
              <button
                type="submit"
                className="c-btn u-width-120"
                disabled={pristine || !valid}
              >
                <span className="c-btn__text">Save</span>
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
);
Form.propTypes = {
  handleSubmit: shapes.handler,
  onDelete: shapes.handler,
  edit: shapes.edit,
  pristine: shapes.pristine,
  submitting: shapes.submitting,
  valid: shapes.valid,
  baseUrl: shapes.url,
  title: shapes.title,
};
Form.defaultProps = {
  handleSubmit: () => null,
  onDelete: () => null,
  edit: false,
  pristine: false,
  submitting: false,
  valid: false,
  baseUrl: '/services/categories',
  title: '',
};

export default Form;

